import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import AiChatPanel from "@/components/AiChatPanel";

export default function AiChatBubble() {
  const [open, setOpen] = useState(false);
  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          data-testid="ai-bubble-open"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-gradient-to-br from-violet-600 to-indigo-600 text-white shadow-lg shadow-violet-600/30 flex items-center justify-center hover:scale-105 transition-transform"
          title="Planlama Asistanı"
        >
          <Sparkles size={24} />
        </button>
      )}
      {open && (
        <div className="fixed bottom-6 right-6 z-50 w-[400px] max-w-[calc(100vw-2rem)] h-[600px] max-h-[calc(100vh-3rem)] rounded-xl border border-zinc-200 bg-white shadow-2xl flex flex-col overflow-hidden" data-testid="ai-bubble-panel">
          <button
            onClick={() => setOpen(false)}
            data-testid="ai-bubble-close"
            className="absolute top-3 right-3 z-10 w-7 h-7 rounded-full hover:bg-zinc-100 flex items-center justify-center text-zinc-400"
          >
            <X size={16} />
          </button>
          <AiChatPanel variant="bubble" />
        </div>
      )}
    </>
  );
}
